import React, { useEffect } from 'react';
import Modal from 'components/Modal';
import { gql } from '@apollo/client';
import { useMutation } from 'hooks/apollo';
import useFormatMessage from 'hooks/useFormatMessage';
import { Button, Form, Input, Space } from 'antd';
import globalMessages from 'translations/messages';
import useGlobalContext from 'hooks/useGlobalContext';

const RENAME_SURVEY = gql`
  mutation RenameSurvey($id: ID!, $title: String!) {
    updateSurvey(id: $id, input: { title: $title }) {
      id
      title
    }
  }
`;

const RENAME_SURVEY_GROUP = gql`
  mutation($id: ID!, $title: String!) {
    updateSurveyGroup(id: $id, input: { title: $title }) {
      id
      title
    }
  }
`;

const RenameSurvey = ({ open, surveyId, surveyGroupId, title, onDone, onCancel }) => {
  const $t = useFormatMessage();
  const { message } = useGlobalContext();
  const [form] = Form.useForm();
  const [renameSurvey, { loading: renameSurveyLoading }] = useMutation(RENAME_SURVEY);
  const [renameSurveyGroup, { loading: renameGroupLoading }] = useMutation(RENAME_SURVEY_GROUP);

  const loading = renameSurveyLoading || renameGroupLoading;

  useEffect(() => {
    form.resetFields();
  }, [open]);

  const onFinish = async (values) => {
    try {
      if (surveyGroupId) {
        await renameSurveyGroup({
          variables: {
            id: surveyGroupId,
            ...values,
          },
        });
      } else {
        await renameSurvey({
          variables: {
            id: surveyId,
            ...values,
          },
        });
      }
      onDone();
    } catch (e) {
      message.error($t(globalMessages.errorFormFeedback));
    }
  };

  return (
    <Modal
      title="Rename survey"
      centered
      open={open}
      footer={(
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={form.submit} loading={loading}>
            Rename
          </Button>
        </Space>
      )}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form requiredMark={false} form={form} layout="vertical" onFinish={onFinish} initialValues={{ title }}>
        <Form.Item name="title" rules={[{ required: true, message: 'Title is required' }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RenameSurvey;
